import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import { concatMap, filter, from, map, pluck, tap } from 'rxjs'
import { setFibInterval } from 'fe-common'
import useLogout from './useLogout'
import { useSubscription } from './observables'

export default function useForceLogoutV2(context) {
  const store = useStore()

  const innerToken = ref(null)
  let reconnectNum = 1

  const token = computed(() => store.state.authModule.token)
  watch(token, newVal => {
    innerToken.value = newVal
  })

  const forceLogout$ = context.root
    .$watchAsObservable(() => innerToken.value)
    .pipe(
      filter(() => process.env.WEB_ENV !== 'local'),
      pluck('newValue'),
      tap(token => {
        if (!token) store.dispatch('websocketModule/disconnect').then()
      }),
      filter(token => !!token),
      map(token => {
        const domain = window.location.hostname
        return `wss://${domain}/socket/websocket/monitor?token=${token}`
      }),
      concatMap(url => from(store.dispatch('websocketModule/connect', url))),
      filter(websocket$ => !!websocket$),
      tap(listeningToForceLogout)
    )

  onMounted(() => {
    useSubscription(forceLogout$, f => f)
    innerToken.value = token.value
  })

  onBeforeUnmount(() => {
    stopListeningToForceLogout()
    store.dispatch('websocketModule/disconnect').then()
  })

  const { logout } = useLogout(context)
  let forceLogoutListener = null
  function listeningToForceLogout(websocket$) {
    forceLogoutListener = websocket$.subscribe({
      next: msg => {
        console.log('msg:', JSON.stringify(msg))
        if (msg && msg.action && msg.action === 'logout') {
          logout()
        }
      },
      error: err => {
        console.error(err)
        innerToken.value = null
        ++reconnectNum
        setFibInterval(
          () => (innerToken.value = token.value),
          reconnectNum,
          reconnectNum
        )
      }
    })
  }
  function stopListeningToForceLogout() {
    if (forceLogoutListener) {
      forceLogoutListener.unsubscribe()
    }
  }
}
